import { CheckCircleIcon, EnvelopeIcon } from "@heroicons/react/24/outline"
import { useSearchParams } from "react-router-dom"
import { Button } from "../shared/Button"
import { Container } from "../shared/Container"
import { Paragraph } from "../shared/Paragraph"
import { Numbers } from "./Numbers"
import vetHero from "/assets/vet.jpg"

export const Hero = () => {
  const [searchParams] = useSearchParams()
  const showSuccess = searchParams.get("email") === "success"
  return (
    <section className="relative pt-32 lg:pt-36">
      {" "}
      <Container className="flex flex-col gap-10 lg:flex-row lg:gap-12">
        <div className="absolute inset-y-0 w-full lg:right-0 lg:w-1/2">
          <span className="absolute top-24 -left-6 hidden h-24 w-24 rotate-90 skew-x-12 rounded-3xl bg-gradient-to-r from-blue-600 to-violet-600 opacity-60 blur-xl md:left-4 lg:top-28 lg:block lg:opacity-95"></span>
          <span className="bg-primary absolute right-4 bottom-12 h-24 w-24 rounded-3xl opacity-80 blur-xl"></span>
        </div>

        <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center lg:mx-0 lg:w-1/2 lg:max-w-none lg:flex-1 lg:items-start lg:py-8 lg:text-left">
          <h1 className="text-heading-1 text-3xl font-bold sm:text-4xl md:text-5xl xl:text-6xl">
            Breeze Thru Follow up with
            <span className="ml-2 bg-gradient-to-r from-blue-600 to-violet-600 bg-clip-text text-transparent">
              TurboDVM{" "}
            </span>
          </h1>
          <Paragraph className="mt-8">
            Designed by veterinarians, TurboDVM seamlessly integrates with your existing lab providers to
            enable you to quickly send follow up emails. Stop wasting time bouncing between windows and
            searching for the information you need. Optimize your workflow with TurboDVM.
          </Paragraph>
          <div className="mx-auto mt-10 flex w-full max-w-lg lg:mx-0">
            {showSuccess ? (
              <div className="flex w-full items-center justify-start gap-3 rounded-full border border-green-200 bg-green-50 px-6 py-4 text-green-800">
                <CheckCircleIcon className="h-6 w-6 text-green-600" />
                <span className="font-medium">Thank you! We'll be in touch soon.</span>
              </div>
            ) : (
              <div className="flex w-full flex-col gap-5 sm:flex-row">
                <form
                  name="hero-email-signup"
                  method="POST"
                  action="/home?email=success"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  className="text-heading-3 shadow-box-shadow border-box-border bg-box-bg focus-within:bg-body focus-within:border-primary flex w-full items-center gap-3 rounded-full border py-1 pr-1 pl-6 shadow-lg ease-linear">
                  <div className="hidden">
                    <label>
                      Don't fill this out if you're human: <input name="bot-field" />
                    </label>
                  </div>
                  <div className="flex w-full items-center gap-4">
                    <span className="min-w-max pr-2">
                      <EnvelopeIcon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <input
                      type="email"
                      name="email"
                      placeholder="your_email@gmail.com"
                      className="input w-full flex-grow bg-transparent py-3"
                      required
                    />
                    <Button type="submit" className="min-w-max text-white">
                      <span className="relative z-[5]">Learn more</span>
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>

        <div className="lg:max-w-non relative mx-auto flex max-w-3xl flex-1 lg:mx-0 lg:h-auto lg:w-1/2">
          <img
            src={vetHero}
            alt="Hero image"
            width={2350}
            height={2359}
            className="lg:max-h-non max-h-96 rounded-3xl object-cover lg:absolute lg:h-full lg:w-full"
          />
        </div>
      </Container>
      <Numbers />
    </section>
  )
}
